export const OPT_OUT_COOKIE = 'vidisape-opt-out';

export function hasConsent(explicit?: boolean): boolean {
  if (explicit === false) return false;
  if (typeof navigator !== 'undefined' && navigator.doNotTrack === '1') return false;
  if (readCookie(OPT_OUT_COOKIE) === '1') return false;
  return true;
}

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const prefix = `${name}=`;
  const value = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length);
  if (value === undefined) return undefined;
  try {
    return decodeURIComponent(value);
  } catch {
    return undefined;
  }
}
